import React from 'react';
import Button from '@mui/material/Button';

interface Subscription {
    subscribed: boolean;
    customerId: string;
    customerEmail: string;
}

interface SubscriptionBlockProps {
    subscription: Subscription;
}

const SubscriptionBlock: React.FC<SubscriptionBlockProps> = ({ subscription }) => {
    return (
        <Button
            onClick={() => {
                document.cookie = `subscribed=true; path=/; max-age=${60 * 60}`;
            }}
            variant="contained"
            color="secondary"
            href={subscription.subscribed ?
                process.env.REACT_APP_STRIPE_MANAGE_SUBSCRIPTION :
                process.env.REACT_APP_STRIPE_NEW_SUBSCRIPTION + "?prefilled_email=" + subscription.customerEmail
                + "&client_reference_id=" + subscription.customerId}
        >
            {subscription.subscribed ? 'Manage Subscription' : 'Subscribe'}
        </Button>
    );
};

export default SubscriptionBlock;